/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/** tempexp_14728-full-file
 * Все упоминания <FeatureSelector selector={getFeatureNewContentGrid} .../>
 */
import classNames from 'clsx';
import { ReactComponent as SharedIcon } from 'img/icons/shared.svg';
import { ReactComponent as AttachIcon } from 'mrg-icons/src/mailru/status/attach.svg';
import React, { memo, ReactElement } from 'react';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { Progress } from 'reactApp/ui/DataListItemRow/components/Progress';
import { Hint } from 'reactApp/ui/Hint/Hint';

import { Checkbox } from './components/Checkbox';
import { Date } from './components/Date';
import { Destination } from './components/Destination';
import { Download } from './components/Download';
import { Expires } from './components/Expires';
import { Favorite } from './components/Favorite';
import { ItemName } from './components/ItemName';
import { ItemTip } from './components/ItemTip/ItemTip';
import { Pic } from './components/Pic';
import { Publish } from './components/Publish';
import { Restore } from './components/Restore';
import { Album } from './components/RowFor/Album';
import { Archive } from './components/RowFor/Archive';
import { Attach } from './components/RowFor/Attach';
import { Favorites } from './components/RowFor/Favorites';
import { Feed } from './components/RowFor/Feed';
import { Gallery } from './components/RowFor/Gallery';
import { Home } from './components/RowFor/Home';
import { Incoming } from './components/RowFor/Incoming';
import { Public } from './components/RowFor/Public';
import { QuotaCleaner } from './components/RowFor/QuotaCleaner';
import { Search } from './components/RowFor/Search';
import { Shared } from './components/RowFor/Shared';
import { Stock } from './components/RowFor/Stock';
import { Trashbin } from './components/RowFor/Trashbin';
import { Size } from './components/Size';
import styles from './DataListItemRow.css';
import newStyles from './DataListItemRow.new.css';
import { DataListItemRowProps } from './DataListItemRow.types';

export const DataListItemRow = memo((props: DataListItemRowProps): ReactElement => {
    const { isSelected, isMobile, isSelecting, isActive, denyDoAction, progress, tipData, isFolder, isPublicDownloaded } = props;

    // eslint-disable-next-line complexity
    const renderItem = (props: DataListItemRowProps) => {
        // eslint-disable-next-line sonarjs/max-switch-cases
        switch (props.storage) {
            case EStorageType.archive:
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Archive {...props} />}
                        control={
                            <>
                                {/* Вернуть когда апи поддержит скачивание нескольких <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} isLarge />*/}
                                <Pic
                                    isFolder={props.isFolder}
                                    kind={props.kind}
                                    isVirus={false}
                                    ext={props.ext || ''}
                                    isLarge={!props.isFolder}
                                />
                                <ItemName name={props.nameWithoutExt || props.name} ext={props.ext || ''} />
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.ext}
                                    size={props.size}
                                    id={props.id}
                                    storage={props.storage}
                                    isHidden={props.isFolder || props.isEncrypted}
                                    isLarge
                                />
                            </>
                        }
                    />
                );
            case EStorageType.sharedIncoming:
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Incoming {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic isFolder={true} kind={props.kind} author={props.owner} />
                                <ItemName name={props.name} />
                                <div className={styles.access}>{props.access === 'read_only' ? 'Просмотр' : 'Редактирование'}</div>
                                <Size size={props.size} />
                                {!props.isMounted ? (
                                    <div className={styles.buttons}>
                                        <Hint text="Принять приглашение">
                                            <button
                                                className={classNames({
                                                    [styles.button]: true,
                                                    [styles.button_accept]: true,
                                                })}
                                                onClick={props.onAccept}
                                            >
                                                Принять
                                            </button>
                                        </Hint>
                                        <Hint text="Отклонить приглашение">
                                            <button className={styles.button} onClick={props.onReject}>
                                                Отклонить
                                            </button>
                                        </Hint>
                                    </div>
                                ) : (
                                    <Hint text="Настроить доступ">
                                        <div className={styles.mount} onClick={props.onMount}>
                                            <SharedIcon width={18} height={12} />
                                        </div>
                                    </Hint>
                                )}
                            </>
                        }
                    />
                );
            case EStorageType.home: {
                const isProgress = denyDoAction;

                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Home {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} isDisabled={denyDoAction} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    kind={props.kind}
                                    isVirus={!!props.isVirus}
                                    ext={props.ext || ''}
                                    author={props.author}
                                    isAutoDelete={props?.isAutoDelete}
                                />
                                <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                                <ItemName name={props.name} ext={props.ext || ''} loading={isProgress} />
                                {!isProgress && (
                                    <Favorite
                                        isAvailable={!!props.favoritesAvailable}
                                        isActive={!!props.isInFavorites}
                                        onClick={props.onFavorites}
                                    />
                                )}
                                {props.isFolder ? (
                                    <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} />
                                ) : (
                                    <Date date={props.mtime} isWide />
                                )}
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.isFolder ? 'zip' : props.ext}
                                    size={props.size}
                                    id={props.id}
                                    storage={props.storage}
                                    show={!isProgress}
                                />
                                {isProgress ? (
                                    <Progress className={styles.progress} progress={progress} onClick={props.onCancelUpload} />
                                ) : (
                                    <Publish onClick={props.onPublish} isActive={props.isPublic} />
                                )}
                            </>
                        }
                    />
                );
            }
            case EStorageType.albums: {
                const isProgress = denyDoAction;

                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Album {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} isDisabled={denyDoAction} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    kind={props.kind}
                                    isVirus={!!props.isVirus}
                                    ext={props.ext || ''}
                                    author={props.author}
                                    isAutoDelete={props?.isAutoDelete}
                                />
                                <ItemName name={props.name} ext={props.ext || ''} loading={isProgress} />
                                {!isProgress && (
                                    <Favorite
                                        isAvailable={!!props.favoritesAvailable}
                                        isActive={!!props.isInFavorites}
                                        onClick={props.onFavorites}
                                    />
                                )}
                                <Date date={props.mtime} isWide />
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.isFolder ? 'zip' : props.ext}
                                    size={props.size}
                                    id={props.id}
                                    storage={props.storage}
                                    show={!isProgress}
                                />
                            </>
                        }
                    />
                );
            }
            case EStorageType.sharedLinks:
            case EStorageType.sharedAutodelete:
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Shared {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    kind={props.kind}
                                    isVirus={!!props.isVirus}
                                    ext={props.ext || ''}
                                    isAutoDelete={props?.isAutoDelete}
                                />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Date date={props.mtime} hide />
                                <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} isShared />
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    size={props.size}
                                    ext={props.isFolder ? 'zip' : props.ext}
                                    id={props.id}
                                    storage={EStorageType.sharedLinks}
                                />
                                <Publish onClick={props.onPublish} isActive={props.isPublic} />
                            </>
                        }
                    />
                );
            case EStorageType.public:
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Public {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    kind={props.kind}
                                    isVirus={!!props.isVirus}
                                    ext={props.ext || ''}
                                    author={props.author}
                                />
                                <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Date date={props.mtime} />
                                <Size size={props.size} />
                                {!isPublicDownloaded && (
                                    <Download
                                        onClick={props.onDownload}
                                        ext={props.isFolder ? 'zip' : props.ext}
                                        size={props.size}
                                        id={props.id}
                                        storage={props.storage}
                                    />
                                )}
                            </>
                        }
                    />
                );
            case EStorageType.favorites:
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Favorites {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    isVirus={!!props.isVirus}
                                    ext={props.ext || ''}
                                    author={props.author}
                                    id={props.id}
                                    kind={props.kind}
                                    isAutoDelete={props?.isAutoDelete}
                                />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Favorite isAvailable isActive onClick={props.onFavorites} isActiveHidden={!props.isSelected} />
                                {props.isFolder ? (
                                    <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} />
                                ) : (
                                    <Date date={props.mtime} isWide />
                                )}
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.ext}
                                    size={props.size}
                                    id={props.id}
                                    storage={props.storage}
                                />
                                <Publish onClick={props.onPublish} isActive={props.isPublic} />
                            </>
                        }
                    />
                );
            case EStorageType.stock:
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Stock {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    kind={props.kind}
                                    thumbUrl={props.thumbUrl}
                                    isFolder={props.isFolder}
                                    isVirus={!!props.isVirus}
                                    ext={props.ext || ''}
                                />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                {props.size && <Size size={props.size} />}
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.ext}
                                    size={props?.size}
                                    id={props.id}
                                    storage={props.storage}
                                />
                            </>
                        }
                    />
                );
            case EStorageType.search: {
                const path = props.home === '/' ? 'Облако' : props.home;

                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Search {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    kind={props.kind}
                                    isVirus={!!props.isVirus}
                                    ext={props.ext || ''}
                                    id={props.id}
                                    isAutoDelete={props?.isAutoDelete}
                                />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Destination name={path} />
                                <Favorite
                                    isAvailable={!!props.favoritesAvailable}
                                    isActive={!!props.isInFavorites}
                                    onClick={props.onFavorites}
                                />
                                {props.isFolder ? (
                                    <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} />
                                ) : (
                                    <Date date={props.mtime} isWide />
                                )}
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.isFolder ? 'zip' : props.ext}
                                    size={props?.size}
                                    id={props.id}
                                    storage={props.storage}
                                />
                                <Publish onClick={props.onPublish} isActive={props.isPublic} />
                            </>
                        }
                    />
                );
            }
            case EStorageType.feed: {
                const path = props.home === '/' ? 'Облако' : props.home.slice(0, props.home.length);

                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Feed {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic isFolder={props.isFolder} thumbUrl={props.thumbUrl} isVirus={!!props.isVirus} ext={props.ext || ''} />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Destination name={path} />
                                <Date date={props.mtime} />
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.ext}
                                    size={props?.size}
                                    id={props.id}
                                    storage={props.storage}
                                />
                                <Publish onClick={props.onPublish} isActive={props.isPublic} />
                            </>
                        }
                    />
                );
            }
            case EStorageType.gallery: {
                const path = props.home === '/' ? 'Облако' : props.home.slice(0, props.home.length);

                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Gallery {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic isFolder={false} thumbUrl={props.thumbUrl} isVirus={!!props.isVirus} ext={props.ext || ''} />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Favorite
                                    isAvailable={!!props.favoritesAvailable}
                                    isActive={!!props.isInFavorites}
                                    onClick={props.onFavorites}
                                />
                                <Destination name={path} />
                                <Date date={props.mtime} />
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.ext}
                                    size={props?.size}
                                    id={props.id}
                                    storage={props.storage}
                                />
                                <Publish onClick={props.onPublish} isActive={props.isPublic} />
                            </>
                        }
                    />
                );
            }
            case EStorageType.attaches:
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Attach {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    isVirus={false}
                                    ext={props.ext || ''}
                                    author={props.owner}
                                />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Destination name={props.subject} icon={<AttachIcon />} />
                                <Date date={props.mtime} />
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.ext}
                                    size={props.size}
                                    id={props.id}
                                    storage={props.storage}
                                />
                            </>
                        }
                    />
                );
            case EStorageType.trashbin: {
                const path = props.deletedFrom === '/' ? props.binName : props.deletedFrom.slice(0, props.deletedFrom.length - 1);

                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<Trashbin {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    kind={props.kind}
                                    isVirus={false}
                                    ext={props.ext || ''}
                                />
                                <ItemName name={props.name} ext={props.ext || ''} />
                                <Destination name={path} />
                                <Date date={props.deletedAt} />
                                <Size size={props.size} />
                                <Restore onClick={props.onRestore} />
                            </>
                        }
                    />
                );
            }
            case EStorageType.quotaCleaner: {
                return (
                    <FeatureSelector
                        selector={getFeatureNewContentGrid}
                        variant1={<QuotaCleaner {...props} checkboxClassname={newStyles.check} />}
                        control={
                            <>
                                <Checkbox onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                                <Pic
                                    isFolder={props.isFolder}
                                    thumbUrl={props.thumbUrl}
                                    kind={props.kind}
                                    isVirus={props.isVirus}
                                    ext={props.ext}
                                    author={props.author}
                                    isAuthorView={!!props.author}
                                />
                                <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                                <ItemName name={props.name} ext={props.ext} />
                                <Date date={props.date} />
                                <Size size={props.size} />
                                <Download
                                    onClick={props.onDownload}
                                    ext={props.ext}
                                    size={props.size}
                                    id={props.id}
                                    storage={props.storage}
                                />
                            </>
                        }
                    />
                );
            }
        }
    };

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            control={
                <div
                    className={classNames(styles.root, {
                        [styles.root_desktop]: !isMobile,
                        [styles.root_selected]: isSelected,
                        [styles.root_active]: isActive,
                        [styles.root_selecting]: isSelecting,
                    })}
                >
                    {renderItem(props)}
                </div>
            }
            variant1={
                <div
                    className={classNames(newStyles.root, {
                        [newStyles.root_selected]: isSelected,
                        [newStyles.root_active]: isActive,
                        [newStyles.root_selecting]: isSelecting,
                    })}
                >
                    {renderItem(props)}
                </div>
            }
        />
    );
});

DataListItemRow.displayName = 'DataListItemRow';
DataListItemRow.whyDidYouRender = true;
